import { ComponentSpinner } from "@components/spinner";
import useBrandSetup from "./hooks/use-brand-setup";
import BrandSetupForm from "./components/brand-setup-form";

// The gate shown until a brand has said how it pays publishers. Every other brand
// route bounces here, and the sidebar is stripped to this one entry while it's
// pending — but the topbar stays, so the brand switcher is still reachable.
const BrandSetup = () => {
    const { brand, brandsLoaded, methods, onSubmit, loading, showDebitNoteFrequency } = useBrandSetup();
    const { control, formState: { errors, isValid } } = methods;

    if (!brandsLoaded || !brand) {
        return (
            <div className="flex justify-center py-24">
                <ComponentSpinner />
            </div>
        );
    }

    return (
        <div className="p-6">
            <div className="mx-auto w-full max-w-3xl">
                <p className="text-sm font-medium uppercase tracking-wider text-muted">{brand.name}</p>
                <h1 className="mt-2 font-display text-3xl font-semibold tracking-tight text-navy">Set up your workspace</h1>
                <p className="mt-2 text-sm text-muted">A few questions before you start. These define how your publishers get paid.</p>

                <BrandSetupForm
                    control={control}
                    errors={errors}
                    isValid={isValid}
                    loading={loading}
                    showDebitNoteFrequency={showDebitNoteFrequency}
                    onSubmit={onSubmit} />
            </div>
        </div>
    );
};

export default BrandSetup;
